import { Component } from 'react';

export class ThickArrowSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                width="15"
                height="8"
                className={className}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M.89 4.004L4.688 7.8V4.654h10.301v-1.3h-10.3V.207L.89 4.004z"
                    fill="#122E4A"
                />
            </svg>
        );
    }
}
